<template>
  <article v-if="notice" class="media tw-p-3">
    <figure class="media-left">
      <p class="image is-64x64 tw-p-2">
        <img class="is-rounded" :src="notice.user.avatar_thumb_url" />
      </p>
    </figure>
    <div class="media-content">
      <div class="content">
        <p class="has-text-black has-text-weight-bold is-size-5 is-marginless">
          {{ notice.user.full_name }}
        </p>
        <p class="is-size-6">
          {{ contentPreview }}
          <span
            @click="showMore"
            class="has-text-primary tw-cursor-pointer"
            v-if="canSeeMore"
          >
            (see more)
          </span>
        </p>

        <p class="is-size-6 tw-text-grey-lighter">
          <small>{{ notice.createdAtFromNow }}</small>
        </p>
      </div>
    </div>
  </article>
</template>

<script>
import Notice from '@/models/Notice'
export default {
  props: {
    seeMore: {
      type: Boolean,
      default: false
    },
    notice: {
      type: Notice
    },
    maxWords: {
      default: 20,
      type: Number
    }
  },
  data() {
    return {
      showAllContent: false
    }
  },
  computed: {
    /**
     * Check if notice content is too long
     */
    canSeeMore() {
      if (!this.seeMore || this.showAllContent) {
        return false
      }
      return this.notice.notice.split(' ').length > this.maxWords
    },
    /**
     * Get truncated version of notice content
     */
    contentPreview() {
      if (this.canSeeMore && !this.showAllContent) {
        return this.notice.notice
          .split(' ')
          .splice(0, this.maxWords)
          .join(' ')
      }
      return this.notice.notice
    }
  },
  methods: {
    showMore() {
      this.showAllContent = true
    }
  }
}
</script>
